module.exports = __webpack_public_path__ + "img/11.db273e1c.jpg";